import {
  accreditationLimitIfTrial,
  allowedUserType,
  eventQuota,
  isVerifiedByCoreEvent,
  modulesRequired,
  some,
} from '../rules'
import CustomSuccessfulPayment from '../../components/accreditations/CustomSuccessfulPayment.vue'
import SuccessfulPayment from '../../components/accreditations/SuccessfulPayment.vue'
import OrganizationCreateContainer from '../../components/organizations/OrganizationCreateContainer.vue'
import OrganizationsListContainer from '../../components/organizations/OrganizationsListContainer.vue'
import OrganizationLiveEventsListContainer from '../../components/organizations/events/OrganizationLiveEventsListContainer.vue'
import OrganizationPastEventsListContainer from '../../components/organizations/events/OrganizationPastEventsListContainer.vue'
import PromoCodeInfoContainer from '../../components/organizations/promo-codes/PromoCodeInfoContainer.vue'
import PromoCodesContainer from '../../components/organizations/promo-codes/PromoCodesContainer.vue'
import { mainRouteNames } from '../routeNames/mainRouteNames'
import { getPropsFromParams } from '../utils.routing'
import AccreditationUpdateContainer from './../../components/accreditations/AccreditationUpdateContainer.vue'
import EventRequestsContainer from './../../components/accreditations/EventRequestsContainer.vue'
import InviteEditContainer from './../../components/accreditations/invite/InviteEditContainer.vue'
import AttendeeFieldsContainer from './../../components/events/AttendeeFieldsContainer.vue'
import EventCategoriesContainer from './../../components/events/EventCategoriesContainer.vue'
import EventCreateContainer from './../../components/events/EventCreateContainer.vue'
import EventUsersContainer from './../../components/events/EventUsersContainer.vue'
import EventsListContainer from './../../components/events/EventsListContainer.vue'
import ImportContainer from './../../components/import-export/ImportContainer.vue'
import Subscribers from './../../components/organizations/mailing-list/subscribers.vue'
import OrganizerSidebar from './../../components/shared/sidebars/organizer/OrganizerSidebar.vue'
import InviteContainer from './../../components/user/InviteContainer.vue'
import OrganizerProfileContainer from './../../components/user/OrganizerProfileContainer.vue'
import TrialAccountInviteContainer from './../../components/user/TrialAccountInviteContainer.vue'
import OrganizerFinanceInfo from './../../components/user/finance-info.vue'
import {
  sportOrganizationRouteNames,
  sportOrganizerRouteNames,
} from '@/routing/routeNames/sportOrganizerRouteNames'
import TicketStatistics from '../../components/stats/ticket-statistics-container.vue'
import FloorPlanOverview from '@/components/stats/floor-plan-overview.vue'
import VisitorStatsContainer from '@/components/stats/visitor/visitor-stats-container.vue'
import ScannedTicketsContainer from '@/components/stats/scanned-tickets-container.vue'
import AccreditationsListContainer from '@/components/accreditations/AccreditationsListContainer.vue'
import AccreditationCreateContainer from '@/components/accreditations/AccreditationCreateContainer.vue'
import ImportExportContainer from '@/components/import-export/ImportExportContainer.vue'
import ExportContainer from '@/components/import-export/ExportContainer.vue'
import EmailsListContainer from '@/components/emails/EmailsListContainer.vue'
import EmailCreateContainer from '@/components/emails/EmailCreateContainer.vue'
import EmailDetailsContainer from '@/components/emails/EmailDetailsContainer.vue'
import EmailUpdateContainer from '@/components/emails/EmailUpdateContainer.vue'
import InviteAttendeeContainer from '@/components/accreditations/InviteAttendeeContainer.vue'
import TicketListContainer from '@/components/tickets/TicketListContainer.vue'
import TicketCreateContainer from '@/components/tickets/TicketCreateContainer.vue'
import GratisTicketCreateContainer from '@/components/tickets/GratisTicketCreateContainer.vue'
import TicketEditContainer from '@/components/tickets/TicketEditContainer.vue'
import FloorPlanContainer from '@/components/tickets/FloorPlanContainer.vue'
import EventInfoContainer from '@/components/events/EventInfoContainer.vue'
import TicketsCategoriesContainer from '@/components/organizations/ticket-categories/TicketsCategoriesContainer.vue'
import Messages from '@/components/organizations/mailing-list/Messages.vue'
import OrganizationUsers from '@/components/organizations/users/organization-users.vue'
import ScanEntriesContainer from '@/components/scan/ScanEntriesContainer.vue'
import SportOrganizationSidebar from '@/components/shared/sidebars/sport-organization/SportOrganizationSidebar.vue'
import WorkShopListContainer from '@/components/workshops/WorkshopListContainer.vue'
import NewWorkshopContainer from '@/components/workshops/NewWorkshopContainer.vue'
import UpdateWorkshopContainer from '@/components/workshops/UpdateWorkshopContainer.vue'
import OrganizationReportsContainer from '@/components/organizations/reports/OrganizationReportsContainer.vue'
import SportSubscriptionsPlanContainer from '@/components/organizations/subscriptions/SportSubscriptionsPlanContainer.vue'
import SportSubscriptionsList from '@/components/organizations/subscriptions/SportSubscriptionsList.vue'
import SportSubscriptionsEmails from '@/components/organizations/subscriptions/SportSubscriptionsEmails.vue'
import SportSubscriptionRequirements from '@/components/organizations/subscriptions/SportSubscriptionRequirements.vue'
import SportSubscriptionsImport from '@/components/organizations/subscriptions/SportSubscriptionsImport.vue'
import SportSubscriptionsCreateEmail from '@/components/organizations/subscriptions/SportSubscriptionsCreateEmail.vue'
import StoreSuccessfulPayment from '@/components/accreditations/organization-store/StoreSuccessfulPayment.vue'
import SportMembershipsContainer from '@/components/organizations/memberships/SportMembershipsContainer.vue'
import SportMembersList from '@/components/organizations/memberships/SportMembersList.vue'
import SportMembershipsEmails from '@/components/organizations/memberships/SportMembershipsEmails.vue'
import SportMembershipsCreateEmail from '@/components/organizations/memberships/SportMembershipsCreateEmail.vue'
import SportMembershipRequirements from '@/components/organizations/memberships/SportMembershipRequirements.vue'
import SportMembershipsImport from '@/components/organizations/memberships/SportMembershipsImport.vue'
import MemberContainer from '@/components/organizations/memberships/MemberContainer.vue'
import SportMembershipsEmailsNew from '@/components/organizations/memberships/SportMembershipsEmailsNew.vue'
import SubscriptionContainer from '@/components/organizations/subscriptions/SubscriptionContainer.vue'
import SportSubscriptionsStatistics from '@/components/organizations/subscriptions/SportSubscriptionsStatistics.vue'
import SportMembershipsStatistics from '@/components/organizations/memberships/SportMembershipsStatistics.vue'
import DocumentationContainer from '@/components/event-documentation/DocumentationContainer.vue'

const sportOrganizerDashboardSidebarRoutes = [
  {
    path: '/sport-organizations/:organizationSlug/events/:eventId/dashboard',
    props: getPropsFromParams,
    name: sportOrganizerRouteNames.eventDashboardSport,
    component: TicketStatistics,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Ticket statistics',
    },
  },
  {
    path: '/sport-organizations/:organizationSlug/events/:eventId/floor-plan-overview',
    props: getPropsFromParams,
    name: sportOrganizerRouteNames.sportFloorPlanOverview,
    component: FloorPlanOverview,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Floor plan overview',
    },
  },
  {
    path: '/sport-organizations/:organizationSlug/events/:eventId/stats/visitors',
    props: getPropsFromParams,
    name: sportOrganizerRouteNames.visitorStatisticsSport,
    component: VisitorStatsContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Visitor statistics',
    },
  },
  {
    path: '/sport-organizations/:organizationSlug/events/:eventId/stats/scanned',
    props: getPropsFromParams,
    name: sportOrganizerRouteNames.scannedTicketsSport,
    component: ScannedTicketsContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Scanned tickets',
    },
  },
]

const attendeeListSidebarRoutes = [
  {
    path: '/sport-organizations/:organizationSlug/events/:eventId/accreditations',
    props: getPropsFromParams,
    name: sportOrganizerRouteNames.accreditationsSport,
    component: AccreditationsListContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Attendee list',
    },
  },
  {
    path: '/sport-organizations/:organizationSlug/events/:eventId/accreditations/new',
    props: getPropsFromParams,
    name: sportOrganizerRouteNames.createAccreditationSport,
    component: AccreditationCreateContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      eventRules: [accreditationLimitIfTrial()],
      title: 'New Accreditation',
    },
  },
  {
    path: '/sport-organizations/:organizationSlug/events/:eventId/accreditation/:accreditationId/edit',
    props: getPropsFromParams,
    name: sportOrganizerRouteNames.editAccreditationSport,
    component: AccreditationUpdateContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Update Accreditation',
    },
  },
]

const importExportSidebarRoutes = [
  {
    path: '/sport-organizations/:organizationSlug/events/:eventId/data',
    props: getPropsFromParams,
    name: sportOrganizerRouteNames.importExportSport,
    component: ImportExportContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'What do you need?',
    },
  },
  {
    path: '/sport-organizations/:organizationSlug/events/:eventId/data/import',
    props: getPropsFromParams,
    name: sportOrganizerRouteNames.importSport,
    component: ImportContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Import',
    },
  },
  {
    path: '/sport-organizations/:organizationSlug/events/:eventId/data/export',
    props: getPropsFromParams,
    name: sportOrganizerRouteNames.exportSport,
    component: ExportContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Export',
    },
  },
]

const emailsSidebarRoutes = [
  {
    path: '/sport-organizations/:organizationSlug/events/:eventId/emails',
    props: getPropsFromParams,
    name: sportOrganizerRouteNames.emailsSport,
    component: EmailsListContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [isVerifiedByCoreEvent()],
      title: 'Emails to attendees',
    },
  },
  {
    path: '/sport-organizations/:organizationSlug/events/:eventId/emails/new',
    props: getPropsFromParams,
    name: sportOrganizerRouteNames.createEmailSport,
    component: EmailCreateContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [isVerifiedByCoreEvent()],
      title: 'Create email',
    },
  },
  {
    path: '/sport-organizations/:organizationSlug/events/:eventId/emails/:emailId/details',
    props: getPropsFromParams,
    name: sportOrganizerRouteNames.emailDetailsSport,
    component: EmailDetailsContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [isVerifiedByCoreEvent()],
      title: 'Email details',
    },
  },
  {
    path: '/sport-organizations/:organizationSlug/events/:eventId/emails/:emailId/update',
    props: getPropsFromParams,
    name: sportOrganizerRouteNames.updateEmailSport,
    component: EmailUpdateContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [isVerifiedByCoreEvent()],
      title: 'Update automated email',
    },
  },
]

const inviteAttendeesSidebarRoute = [
  {
    path: '/sport-organizations/:organizationSlug/events/:eventId/invite-attendee',
    props: getPropsFromParams,
    name: sportOrganizerRouteNames.inviteAttendeeSport,
    component: InviteAttendeeContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Invite attendees',
    },
  },
]

const pendingRequestsSidebarRoutes = [
  {
    path: '/sport-organizations/:organizationSlug/events/:eventId/requests',
    props: getPropsFromParams,
    name: sportOrganizerRouteNames.requestsSport,
    component: EventRequestsContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Attendance requests',
    },
  },
]

const editInviteSidebarRoutes = [
  {
    path: '/sport-organizations/:organizationSlug/events/:eventId/edit-invite',
    props: getPropsFromParams,
    name: sportOrganizerRouteNames.editInviteSport,
    component: InviteEditContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Edit invite information',
    },
  },
]

const documentationSidebarRoutes = [
  {
    path: '/sport-organizations/:organizationSlug/events/:eventId/documentation',
    props: getPropsFromParams,
    name: sportOrganizerRouteNames.eventDocumentationSport,
    component: DocumentationContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Documentation',
    },
  },
]

const ticketsSidebarRoutes = [
  {
    path: '/sport-organizations/:organizationSlug/events/:eventId/tickets',
    props: getPropsFromParams,
    name: sportOrganizerRouteNames.ticketsSport,
    component: TicketListContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Tickets',
    },
  },
  {
    path: '/sport-organizations/:organizationSlug/events/:eventId/tickets/new/:type',
    props: getPropsFromParams,
    name: sportOrganizerRouteNames.createTicketSport,
    component: TicketCreateContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Create ticket',
    },
  },
  {
    path: '/sport-organizations/:organizationSlug/events/:eventId/tickets/new-gratis',
    props: getPropsFromParams,
    name: sportOrganizerRouteNames.createGratisTicketSport,
    component: GratisTicketCreateContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Create gratis ticket',
    },
  },
  {
    path: '/sport-organizations/:organizationSlug/events/:eventId/tickets/:ticketId/edit',
    props: getPropsFromParams,
    name: sportOrganizerRouteNames.editTicketSport,
    component: TicketEditContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Update ticket',
    },
  },
]

const floorPlanSidebarRoutes = [
  {
    path: '/sport-organizations/:organizationSlug/events/:eventId/floor-plan',
    props: getPropsFromParams,
    name: sportOrganizerRouteNames.floorPlanSport,
    component: FloorPlanContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Floor plan',
    },
  },
]

const eventInfoSidebarRoutes = [
  {
    path: '/sport-organizations/:organizationSlug/events/:eventId/info',
    props: getPropsFromParams,
    name: sportOrganizerRouteNames.eventInfoSport,
    component: EventInfoContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Event info',
    },
  },
]

const usersSidebarRoutes = [
  {
    path: '/sport-organizations/:organizationSlug/events/:eventId/event-workers',
    props: getPropsFromParams,
    name: sportOrganizerRouteNames.eventWorkersSport,
    component: EventUsersContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'EventWorkers',
    },
  },
]

const categoriesSidebarRoutes = [
  {
    path: '/sport-organizations/:organizationSlug/events/:eventId/categories',
    props: getPropsFromParams,
    name: sportOrganizerRouteNames.eventCategoriesSport,
    component: EventCategoriesContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      eventRules: [modulesRequired(['categoriesAndZones'])],
      title: 'Categories',
    },
  },
]

const attendeeFieldsSidebarRoutes = [
  {
    path: '/sport-organizations/:organizationSlug/events/:eventId/attendee-fields',
    props: getPropsFromParams,
    name: sportOrganizerRouteNames.attendeeFieldsSport,
    component: AttendeeFieldsContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Attendee fields',
    },
  },
]

const workshopsSidebarRoutes = [
  {
    path: '/sport-organizations/:organizationSlug/events/:eventId/workshops',
    props: getPropsFromParams,
    name: sportOrganizerRouteNames.sportEventWorkshops,
    component: WorkShopListContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      eventRules: [modulesRequired(['workshops', 'conferenceMobileApp'], some)],
      title: 'Workshops',
    },
  },
  {
    path: '/sport-organizations/:organizationSlug/events/:eventId/workshops/new',
    props: getPropsFromParams,
    name: sportOrganizerRouteNames.newWorkshopSport,
    component: NewWorkshopContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      eventRules: [modulesRequired(['workshops', 'conferenceMobileApp'], some)],
      title: 'Create Workshop',
    },
  },
  {
    path: '/sport-organizations/:organizationSlug/events/:eventId/workshops/:workshopId',
    props: getPropsFromParams,
    name: sportOrganizerRouteNames.updateWorkshopSport,
    component: UpdateWorkshopContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      eventRules: [modulesRequired(['workshops', 'conferenceMobileApp'], some)],
      title: 'Update Workshop',
    },
  },
]

const sportOrganizationEventsSidebarRoutes = [
  {
    path: '/sport-organizations/:organizationSlug/live-events',
    name: sportOrganizationRouteNames.sportLiveEvents,
    props: getPropsFromParams,
    component: OrganizationLiveEventsListContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['REGULAR', 'TRIAL', 'SUPER_ADMIN'])],
      title: 'Live events',
    },
  },
  {
    path: '/sport-organizations/:organizationSlug/past-events',
    name: sportOrganizationRouteNames.sportPastEvents,
    props: getPropsFromParams,
    component: OrganizationPastEventsListContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['REGULAR', 'TRIAL', 'SUPER_ADMIN'])],
      title: 'Past events',
    },
  },
]
const sportOrganizationSubscriptionsSidebarRoutes = [
  {
    path: '/sport-organizations/:organizationSlug/subscriptions-plan',
    name: sportOrganizationRouteNames.sportOrganizationSubscriptionsPlan,
    props: getPropsFromParams,
    component: SportSubscriptionsPlanContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['REGULAR', 'SUPER_ADMIN'])],
      title: 'Subscriptions plan',
    },
  },
  {
    path: '/sport-organizations/:organizationSlug/subscriptions-list',
    name: sportOrganizationRouteNames.sportOrganizationSubscriptionsList,
    props: getPropsFromParams,
    component: SportSubscriptionsList,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['REGULAR', 'SUPER_ADMIN'])],
      title: 'Subscriptions list',
    },
  },
  {
    path: '/sport-organizations/:organizationSlug/subscription/create',
    name: sportOrganizationRouteNames.sportOrganizationSubscriptionCreate,
    props: getPropsFromParams,
    component: SubscriptionContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['REGULAR', 'SUPER_ADMIN'])],
      title: 'Subscription create',
    },
  },
  {
    path: '/sport-organizations/:organizationSlug/subscription/update/:id',
    name: sportOrganizationRouteNames.sportOrganizationSubscriptionUpdate,
    props: getPropsFromParams,
    component: SubscriptionContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['REGULAR', 'SUPER_ADMIN'])],
      title: 'Subscription update',
    },
  },
  {
    path: '/sport-organizations/:organizationSlug/subscriptions-emails',
    name: sportOrganizationRouteNames.sportOrganizationSubscriptionsEmails,
    props: getPropsFromParams,
    component: SportSubscriptionsEmails,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['REGULAR', 'SUPER_ADMIN'])],
      title: 'Subscriptions Emails',
    },
  },
  {
    path: '/sport-organizations/:organizationSlug/subscriptions-emails/new',
    name: sportOrganizationRouteNames.sportOrganizationCreateSubscriptionEmail,
    props: getPropsFromParams,
    component: SportSubscriptionsCreateEmail,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['REGULAR', 'SUPER_ADMIN'])],
      title: 'Create e-mail',
    },
  },
  {
    path: '/sport-organizations/:organizationSlug/subscription-requirements',
    name: sportOrganizationRouteNames.sportOrganizationSubscriptionRequirements,
    props: getPropsFromParams,
    component: SportSubscriptionRequirements,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['REGULAR', 'SUPER_ADMIN'])],
      title: 'Subscription Requirements',
    },
  },
  {
    path: '/sport-organizations/:organizationSlug/subscriptions-import',
    name: sportOrganizationRouteNames.sportOrganizationSubscriptionsImport,
    props: getPropsFromParams,
    component: SportSubscriptionsImport,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['REGULAR', 'SUPER_ADMIN'])],
      title: 'Subscription Import',
    },
  },
  {
    path: '/sport-organizations/:organizationSlug/subscriptions-statistics',
    name: sportOrganizationRouteNames.sportOrganizationSubscriptionStatistics,
    props: getPropsFromParams,
    component: SportSubscriptionsStatistics,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['REGULAR', 'SUPER_ADMIN'])],
      title: 'Subscription Statistics',
    },
  },
]
const sportOrganizationMembershipsSidebarRoutes = [
  {
    path: '/sport-organizations/:organizationSlug/membership-plans',
    name: sportOrganizationRouteNames.sportOrganizationMemberships,
    props: getPropsFromParams,
    component: SportMembershipsContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['REGULAR', 'SUPER_ADMIN'])],
      title: 'Memberships',
    },
  },
  {
    path: '/sport-organizations/:organizationSlug/members-list',
    name: sportOrganizationRouteNames.sportOrganizationMembersList,
    props: getPropsFromParams,
    component: SportMembersList,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['REGULAR', 'SUPER_ADMIN'])],
      title: 'Members list',
    },
  },
  {
    path: '/sport-organizations/:organizationSlug/memberships-import',
    name: sportOrganizationRouteNames.sportOrganizationMembershipsImport,
    props: getPropsFromParams,
    component: SportMembershipsImport,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['REGULAR', 'SUPER_ADMIN'])],
      title: 'Memberships Import',
    },
  },
  {
    path: '/sport-organizations/:organizationSlug/members/create',
    name: sportOrganizationRouteNames.sportOrganizationMembersCreate,
    props: getPropsFromParams,
    component: MemberContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['REGULAR', 'SUPER_ADMIN'])],
      title: 'Member create',
    },
  },
  {
    path: '/sport-organizations/:organizationSlug/members/update/:id',
    name: sportOrganizationRouteNames.sportOrganizationMembersUpdate,
    props: getPropsFromParams,
    component: MemberContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['REGULAR', 'SUPER_ADMIN'])],
      title: 'Member update',
    },
  },
  {
    path: '/sport-organizations/:organizationSlug/memberships-emails',
    name: sportOrganizationRouteNames.sportOrganizationMembershipsEmails,
    props: getPropsFromParams,
    component: SportMembershipsEmails,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['REGULAR', 'SUPER_ADMIN'])],
      title: 'Membership Emails',
    },
  },
  {
    path: '/sport-organizations/:organizationSlug/membership-emails/new',
    props: getPropsFromParams,
    name: sportOrganizationRouteNames.sportOrganizationMembershipsEmailsNew,
    component: SportMembershipsEmailsNew,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [isVerifiedByCoreEvent()],
      title: 'Create email',
    },
  },
  {
    path: '/sport-organizations/:organizationSlug/memberships-emails/new',
    name: sportOrganizationRouteNames.sportOrganizationMembershipsEmailsNew,
    props: getPropsFromParams,
    component: SportMembershipsCreateEmail,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['REGULAR', 'SUPER_ADMIN'])],
      title: 'Create e-mail',
    },
  },
  {
    path: '/sport-organizations/:organizationSlug/membership-requirements',
    name: sportOrganizationRouteNames.sportOrganizationMembershipRequirements,
    props: getPropsFromParams,
    component: SportMembershipRequirements,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['REGULAR', 'SUPER_ADMIN'])],
      title: 'Membership Requirements',
    },
  },
  {
    path: '/sport-organizations/:organizationSlug/memberships-import',
    name: sportOrganizationRouteNames.sportOrganizationSubscriptionsImport,
    props: getPropsFromParams,
    component: SportMembershipsImport,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['REGULAR', 'SUPER_ADMIN'])],
      title: 'Subscription Import',
    },
  },
  {
    path: '/sport-organizations/:organizationSlug/memberships-statistics',
    name: sportOrganizationRouteNames.sportOrganizationMembershipStatistics,
    props: getPropsFromParams,
    component: SportMembershipsStatistics,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['REGULAR', 'SUPER_ADMIN'])],
      title: 'Membership Statistics',
    },
  },
]

const sportOrganizationInfoSidebarRoutes = [
  {
    path: '/sport-organizations/:organizationSlug/organization-info',
    props: getPropsFromParams,
    name: sportOrganizationRouteNames.sportOrganizationProfileInfo,
    component: OrganizerProfileContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['REGULAR', 'SUPER_ADMIN'])],
      title: 'Organization info',
    },
  },
]

const financeInfoSidebarRoutes = [
  {
    path: '/sport-organizations/:organizationSlug/finance-info',
    props: getPropsFromParams,
    name: sportOrganizationRouteNames.sportOrganizationFinanceInfo,
    component: OrganizerFinanceInfo,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['REGULAR', 'TRIAL', 'SUPER_ADMIN'])],
      title: 'Finance info',
    },
  },
]

const ticketCategoriesSidebarRoutes = [
  {
    path: '/sport-organizations/:organizationSlug/ticket-categories',
    props: getPropsFromParams,
    name: sportOrganizationRouteNames.sportOrganizationTicketCategories,
    component: TicketsCategoriesContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['REGULAR', 'TRIAL', 'SUPER_ADMIN'])],
      title: 'Ticket categories',
    },
  },
]

const subscribersSidebarRoutes = [
  {
    path: '/sport-organizations/:organizationSlug/subscribers',
    props: getPropsFromParams,
    name: sportOrganizationRouteNames.sportOrganizationSubscribers,
    component: Subscribers,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['REGULAR', 'TRIAL', 'SUPER_ADMIN'])],
      title: 'Subscribers',
    },
  },
  {
    path: '/sport-organizations/:organizationSlug/messages',
    props: getPropsFromParams,
    name: sportOrganizationRouteNames.sportOrganizationMessages,
    component: Messages,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['REGULAR', 'TRIAL', 'SUPER_ADMIN'])],
      title: 'Messages',
    },
  },
]

const organizationUsersSidebarRoutes = [
  {
    path: '/sport-organizations/:organizationSlug/organization-users',
    props: getPropsFromParams,
    name: sportOrganizationRouteNames.sportOrganizationUsers,
    component: OrganizationUsers,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['REGULAR', 'TRIAL', 'SUPER_ADMIN'])],
      title: 'OrganizationUsers',
    },
  },
]

const sportPromoCodesSidebarRoutes = [
  {
    path: '/sport-organizations/:organizationSlug/promo-codes',
    props: getPropsFromParams,
    name: sportOrganizationRouteNames.sportOrganizationPromoCodes,
    component: PromoCodesContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['REGULAR', 'SUPER_ADMIN'])],
      title: 'Promo codes',
    },
  },
  {
    path: '/sport-organizations/:organizationSlug/promo-codes/:promoCodeId',
    props: getPropsFromParams,
    name: sportOrganizationRouteNames.sportOrganizationPromoCodeInfo,
    component: PromoCodeInfoContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['REGULAR', 'SUPER_ADMIN'])],
      title: 'Promo code',
    },
  },
]

const scanEntriesSidebarRoutes = [
  {
    path: '/sport-organizations/:organizationSlug/events/:eventId/scan-entries',
    props: getPropsFromParams,
    name: sportOrganizerRouteNames.scanEntriesSport,
    component: ScanEntriesContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      eventRules: [modulesRequired(['scanEntries'])],
    },
  },
]

const sportOrganizationSidebarRoutes = [
  ...sportOrganizationEventsSidebarRoutes,
  ...sportOrganizationSubscriptionsSidebarRoutes,
  ...sportOrganizationInfoSidebarRoutes,
  ...financeInfoSidebarRoutes,
  ...subscribersSidebarRoutes,
  ...sportPromoCodesSidebarRoutes,
  ...sportOrganizationMembershipsSidebarRoutes,
  ...ticketCategoriesSidebarRoutes,
  ...organizationUsersSidebarRoutes,
  ...scanEntriesSidebarRoutes,
]

const sportOrganizerSidebarRoutes = [
  ...sportOrganizerDashboardSidebarRoutes,
  ...attendeeListSidebarRoutes,
  ...importExportSidebarRoutes,
  ...emailsSidebarRoutes,
  ...inviteAttendeesSidebarRoute,
  ...pendingRequestsSidebarRoutes,
  ...editInviteSidebarRoutes,
  ...documentationSidebarRoutes,
  ...ticketsSidebarRoutes,
  ...eventInfoSidebarRoutes,
  ...usersSidebarRoutes,
  ...categoriesSidebarRoutes,
  ...attendeeFieldsSidebarRoutes,
  ...floorPlanSidebarRoutes,
  ...workshopsSidebarRoutes,
]

const nonSidebarRoutes = [
  {
    path: '/events',
    name: sportOrganizerRouteNames.eventsSport,
    props: getPropsFromParams,
    component: EventsListContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['EVENT_WORKER'])],
    },
  },
  {
    path: '/',
    name: sportOrganizerRouteNames.organizationsSport,
    props: getPropsFromParams,
    component: OrganizationsListContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['REGULAR', 'SUPER_ADMIN'])],
    },
  },
  {
    path: '/sport-organizations/new',
    name: sportOrganizerRouteNames.createOrganizationSport,
    component: OrganizationCreateContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['REGULAR', 'SUPER_ADMIN'])],
    },
  },
  {
    path: '/sport-organizations/:organizationSlug/events/new',
    name: sportOrganizationRouteNames.sportOrganizationAddEvent,
    props: getPropsFromParams,
    component: EventCreateContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [eventQuota(), allowedUserType(['REGULAR', 'SUPER_ADMIN'])],
    },
  },
  {
    path: '/invite/:inviteToken',
    name: sportOrganizerRouteNames.inviteSport,
    component: InviteContainer,
    meta: {
      requiresAuthentication: false,
      redirectIfAuthenticated: false,
      hideProAccountButton: true,
    },
    props: getPropsFromParams,
  },
  {
    path: '/create-trial-account',
    props: getPropsFromParams,
    name: sportOrganizerRouteNames.createTrialAccountSport,
    component: TrialAccountInviteContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['REGULAR', 'SUPER_ADMIN'])],
      hideProAccountButton: true,
    },
  },
  {
    path: '/successful-payment/:orderUUID',
    props: getPropsFromParams,
    name: sportOrganizerRouteNames.successfulPaymentSport,
    component: SuccessfulPayment,
    meta: {
      requiresAuthentication: false,
      redirectIfAuthenticated: false,
      hideProAccountButton: true,
    },
  },
  {
    path: '/store-successful-payment/:orderUUID',
    props: getPropsFromParams,
    name: sportOrganizerRouteNames.storeSuccessfulPaymentSport,
    component: StoreSuccessfulPayment,
    meta: {
      requiresAuthentication: false,
      redirectIfAuthenticated: false,
      hideProAccountButton: true,
    },
  },
  {
    path: '/custom-successful-payment/:orderUUID',
    props: getPropsFromParams,
    name: sportOrganizerRouteNames.customSuccessfulPaymentSport,
    component: CustomSuccessfulPayment,
    meta: {
      requiresAuthentication: false,
      redirectIfAuthenticated: false,
      hideProAccountButton: true,
    },
  },
  {
    path: '/sport-organizations/:organizationSlug/reports',
    props: getPropsFromParams,
    name: sportOrganizationRouteNames.sportOrganizationReports,
    component: OrganizationReportsContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['REGULAR', 'SUPER_ADMIN'])],
      title: 'Reports',
    },
  },
]

export const SportOrganizerRoutes = [
  ...nonSidebarRoutes,
  {
    path: '/sport-organizations/:organizationSlug/events/:eventId',
    redirect: { name: sportOrganizerRouteNames.eventDashboardSport },
    name: mainRouteNames.sportOrganizerSidebar,
    props: getPropsFromParams,
    component: OrganizerSidebar,
    meta: {
      requiresAuthentication: true,
      requiresAuthorization: true,
      redirectIfAuthenticated: false,
    },
    children: sportOrganizerSidebarRoutes,
  },
  {
    path: '/sport-organizations/:organizationSlug',
    redirect: { name: sportOrganizationRouteNames.sportLiveEvents },
    name: mainRouteNames.sportOrganizationSidebar,
    props: getPropsFromParams,
    component: SportOrganizationSidebar,
    meta: {
      requiresAuthentication: true,
      requiresAuthorization: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['REGULAR', 'SUPER_ADMIN'])],
    },
    children: sportOrganizationSidebarRoutes,
  },
]
